import { useInitData } from '../../../hooks'
import {
  EmailAccountsProvider,
  LayoutOverlayContextProvider,
} from '../../../providers'
import { AsyncTaskProvider } from '../../AsyncTask'
import { DraftStorageProvider } from '../../Draft'
import { MenuCollapsedStateProvider } from '../../Menu'
import { NotificationProvider } from '../../Notification'

function LayoutProviders({ children }) {
  const { authorized } = useInitData()

  return authorized ? (
    <DraftStorageProvider>
      <MenuCollapsedStateProvider>
        <NotificationProvider>
          <EmailAccountsProvider>
            <AsyncTaskProvider>
              <LayoutOverlayContextProvider>
                {children}
              </LayoutOverlayContextProvider>
            </AsyncTaskProvider>
          </EmailAccountsProvider>
        </NotificationProvider>
      </MenuCollapsedStateProvider>
    </DraftStorageProvider>
  ) : null
}

export default LayoutProviders
